import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { VodCategory } from '../../../configs/stream-entities'

class VideoCategoryDetailProps {
    public videoCategoryId: string
}

class VideoCategoryDetailState extends VodCategory {
    public forceReset: boolean = false
}

class VideoCategoryDetail extends React.Component<VideoCategoryDetailProps, VideoCategoryDetailState> {
    private formRef: React.RefObject<HTMLFormElement>

    constructor(props: VideoCategoryDetailProps) {
        super(props)
        const newState = new VideoCategoryDetailState()
        newState.id = props.videoCategoryId
        this.state = newState
        this.formRef = React.createRef<HTMLFormElement>()
        this.onCategoryNameChange = this.onCategoryNameChange.bind(this)
        this.onCategoryPriorityChange = this.onCategoryPriorityChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.resetForm = this.resetForm.bind(this)
    }

    public componentWillUpdate(nextProps: VideoCategoryDetailProps, nextState: VideoCategoryDetailState) {
        if (this.props.videoCategoryId !== nextProps.videoCategoryId) {
            firebase.firestore().collection('vod').doc('categories').collection('tags').doc(nextProps.videoCategoryId).get().then(snapshot => {
                nextState.id = snapshot.id
                nextState.name = snapshot.data()!.name
                nextState.priority = snapshot.data()!.priority
                this.setState(nextState)
            })
        }
    }

    public render() {
        return (<div className="VideoCategoryDetail">
            <button onClick={this.resetForm}>Reset</button>
            <form ref={this.formRef} onSubmit={this.onSubmit}>
                <label htmlFor="categoryName">Category name:</label>
                <input type="text" name="categoryName" onChange={this.onCategoryNameChange} required={true} value={this.state.name} /><br />
                <label htmlFor="categoryPriority">Category priority (the smaller the number to more important)</label>
                <input type="number" min="0" step="1" name="categoryPriority" onChange={this.onCategoryPriorityChange} required={true} value={this.state.priority} />
                <br />
                <input type="submit" />
            </form>
        </div>)
    }

    private onCategoryNameChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ name: event.target.value })
    }

    private onCategoryPriorityChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ priority: Number(event.target.value) })
    }

    private resetForm(_: any) {
        const newState = new VideoCategoryDetailState()
        this.setState(newState)
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            const categoryCollectionRef = firebase.firestore().collection('vod').doc('categories').collection('tags')
            let categoryRequest: Promise<any>
            let categoryId = ''
            const request = new VodCategory()
            request.name = this.state.name
            request.priority = this.state.priority
            if (this.state.id.length < 1) {
                categoryRequest = categoryCollectionRef.add(Object.assign({}, request)).then(ref => {
                    categoryId = ref.id;
                    return ref.update({id: ref.id});
                })
            } else {
                request.id = this.state.id
                categoryId = this.state.id
                categoryRequest = categoryCollectionRef.doc(request.id).update(Object.assign({}, request))
            }
            categoryRequest.then(_ => {
                this.setState({ id: categoryId })
            }).catch(err => {
                console.error(err)
            })
        }
    }

}

export default VideoCategoryDetail


// WEBPACK FOOTER //
// ./src/components/daily-video/categories/Video-categories-detail.tsx